import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

export const useInvalidateQuantFolders = () => {
  const queryClient = useQueryClient();

  return useCallback((quantAnalysisId: number, projectId: number, versionId?: number) => {
    queryClient.invalidateQueries({
      queryKey: ['getQuantDirectoryTree', projectId, quantAnalysisId, versionId],
    });
  }, [queryClient]);
};